import { render, staticRenderFns } from "./EditProfilePopup.vue?vue&type=template&id=675ad040&scoped=true&"
import script from "./EditProfilePopup.vue?vue&type=script&lang=ts&"
export * from "./EditProfilePopup.vue?vue&type=script&lang=ts&"
import style0 from "./EditProfilePopup.vue?vue&type=style&index=0&id=675ad040&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ad040",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VImg,VTextField})
